import UpdateSleepStoryTranslationRequest from '../../../../../Spirit/Admin/Interfaces/Models/SleepStoryService/UpdateSleepStoryTranslationRequest';
import CropAndSaveImageRequest from '../../../../../Spirit/Common/FileManager/Models/CropAndSaveImageRequest';

export default class UpdateSleepStoryRequest  {
	Id?: number = null;
	UseOnMainDisplay: boolean = false;
	IsPaid: boolean = false;
	AnimationId?: string = '';
	Translations: Array<UpdateSleepStoryTranslationRequest> = null;
	Cover: CropAndSaveImageRequest = null;
	Back: CropAndSaveImageRequest = null;
	Categories: Array<number> = null;
	constructor(obj?: Partial<UpdateSleepStoryRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
